import { StaticImage } from 'gatsby-plugin-image';
import ECOMMERCE_URLS from 'consts/eCommerceUrls';
import {
  CUSTOM_FORMULA_PRICE_PER_MONTH,
  FUTURE_PROOF_PRICE_PER_MONTH,
  HAIR_FORMULA_PRICE_PER_MONTH,
} from 'consts/copy';
import { PAGE_URLS } from 'consts/pageUrls';
import { PRODUCT_LINKS } from 'consts/products';
import {
  EMERGENCY_SPOT_PATCHES_ECOMMERCE_PRICE,
  THE_CLEANSER_ECOMMERCE_PRICE,
  THE_MOISTURIZER_ECOMMERCE_PRICE,
} from 'consts/copy';
import type { SubsectionProps } from '../components';

export const CHIA_PRODUCTS_MODULE: SubsectionProps = {
  moduleName: 'chiaModule',
  title: 'Try prescription skincare',
  productCards: [
    {
      linkType: PRODUCT_LINKS.internal,
      href: PAGE_URLS.products.customFormulaAcne,
      name: 'Custom Formula',
      description: 'Daily Acne Clearing Treatment',
      price: CUSTOM_FORMULA_PRICE_PER_MONTH,
      image: (
        <StaticImage
          src="../images/custom-formula@2x.png"
          alt="A bottle of Curology's Custom Formula."
          objectFit="contain"
        />
      ),
      hideButton: true,
    },
    {
      linkType: PRODUCT_LINKS.internal,
      href: PAGE_URLS.products.hairFormula,
      name: 'Hair Formula',
      tag: 'Rx',
      description: 'Personalized Growth Treatment',
      price: HAIR_FORMULA_PRICE_PER_MONTH,
      image: (
        <StaticImage
          src="../images/hair-formula@2x.png"
          alt="A bottle of Curology's Hair Formula."
          objectFit="contain"
        />
      ),
      imageTag: 'New!',
      hideButton: true,
    },
    {
      linkType: PRODUCT_LINKS.internal,
      href: PAGE_URLS.products.futureProofAntiAging,
      name: 'HydroTret',
      tag: 'Rx',
      description: 'Hydrating Tretinoin-Powered Treatment',
      price: FUTURE_PROOF_PRICE_PER_MONTH,
      image: (
        <StaticImage
          src="../images/hydrotret@2x.png"
          alt="A bottle of Curology's HydroTret."
          objectFit="contain"
        />
      ),
      hideButton: true,
    },
  ],
};

export const CHIA_BOTTOM_PRODUCTS_MODULE: SubsectionProps = {
  moduleName: 'chiaBottomModule',
  title: 'Shop routine essentials',
  productCards: [
    {
      linkType: PRODUCT_LINKS.eCommerce,
      href: ECOMMERCE_URLS.cleanser,
      name: 'The Cleanser',
      description: 'Lightly foaming face wash',
      price: THE_CLEANSER_ECOMMERCE_PRICE,
      image: (
        <StaticImage
          src="../images/cleanser@2x.jpg"
          alt="A bottle of Curology's cleanser."
          objectFit="contain"
        />
      ),
      hideButton: true,
    },
    {
      linkType: PRODUCT_LINKS.eCommerce,
      href: ECOMMERCE_URLS.moisturizer,
      name: 'The Moisturizer',
      description: 'Lightweight daily hydration',
      price: THE_MOISTURIZER_ECOMMERCE_PRICE,
      image: (
        <StaticImage
          src="../images/moisturizer@2x.jpg"
          alt="A bottle of Curology's moisturizer."
          objectFit="contain"
        />
      ),
      hideButton: true,
    },
    {
      linkType: PRODUCT_LINKS.eCommerce,
      href: ECOMMERCE_URLS.emergencySpotPatch,
      name: 'Emergency Spot Patch',
      description: 'Fast-acting healing support',
      price: EMERGENCY_SPOT_PATCHES_ECOMMERCE_PRICE,
      image: (
        <StaticImage
          src="../images/emergency-spot-patches@2x.jpg"
          alt="A package of Curology's emergnency spot patches."
          objectFit="contain"
        />
      ),
      hideButton: true,
    },
  ],
};
